export default __webpack_public_path__ + "static/media/discord-black.142b6931.svg";